import { OfferStatus } from '@core/offers-types';

export enum JobActionsDropdownType {
  Table = 'table',
  List = 'list',
}

export interface JobActionsDropdownOffer {
  status: OfferStatus;
  slug: string;
  url?: string;
}
